import React, { useMemo, useRef, useEffect } from 'react';
import shortUUID from 'short-uuid';
import { ValidateError } from '../ErrorMessage';
import { Tooltip } from '../Tooltip';
import './styles.css';

export const TextArea = ({
  error,
  color,
  className,
  large,
  noPadding,
  id,
  type,
  label,
  disabled,
  required,
  onChange,
  icon,
  iconPosition,
  field,
  form,
  maxLength,
  tooltip,
  defaultFile,
  ...otherProps
}) => {
  const uuid = useMemo(() => shortUUID().generate(), []);
  const fileRef = useRef(null);

  useEffect(() => {
    if (type === 'file' && defaultFile?.file) {
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(defaultFile.file);

      if (fileRef && fileRef.current && fileRef.current.files) {
        fileRef.current.files = dataTransfer.files;
      }
    }
  }, [defaultFile?.file, type]);

  return (
    <div className={className}>
      {label ? (
        <label
          className={`label
              ${disabled ? 'disabled' : ''} ${
            form && field
              ? form.errors[field.name] && form.touched[field.name]
                ? 'error'
                : ''
              : ''
          }`}
          htmlFor={id || uuid}
        >
          {label}
          {tooltip && (
            <Tooltip title={tooltip} arrow placement="right">
              ?
            </Tooltip>
          )}
        </label>
      ) : (
        ''
      )}
      <div
        className={`text-area-wrapper ${color || ''} ${
          label ? '' : 'no-label'
        }`}
      >
        {field && (
          <>
            <textarea
              {...field}
              id={id || uuid}
              className={`text-area ${
                icon ? 'with-icon' : ''
              } ${`icon-${iconPosition}`} ${
                form
                  ? form.errors[field.name] && form.touched[field.name]
                    ? 'error'
                    : ''
                  : ''
              } ${large ? 'large' : ''} ${noPadding ? 'no_padding' : ''}`}
              // maxLength="100px"
              required={required}
              disabled={disabled}
              rows={10}
              colums={1}
              {...otherProps}
              onChange={(e) => {
                if (onChange) {
                  return onChange(e);
                }
                return field.onChange(e);
              }}
            />
            {icon ? (
              <i className={`${icon} ${iconPosition} ${color || ''}`} />
            ) : (
              ''
            )}
            {!form.isValid
              ? form.touched[field.name] &&
                form.errors[field.name] && (
                  <ValidateError>{form.errors[field.name]}</ValidateError>
                )
              : ''}
          </>
        )}
      </div>
    </div>
  );
};
